import { AbstractControl, ValidationErrors } from '@angular/forms'
import { throttleTime } from 'rxjs/operators'
import { environment } from './environments/environment'

// export function getMailingOrderBasePath(mailingOrderId: string | undefined) {
//     return Utils.getMailingOrderBasePath(mailingOrderId)
// }

export function logDebug(msg: unknown) {
    if (environment.production) {
        return
    }
    console.log(msg)
}

export function throttleTimeLeadingAndTrailing<T>(ms: number) {
    return throttleTime<T>(ms, undefined, { leading: true, trailing: true })
}

export function wait(ms: number) {
    return new Promise<void>((resolve) => setTimeout(resolve, ms))
}

export function noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
    if (control.value && control.value.trim().length === 0) {
        return { noWhitespace: true }
    }
    return null
}
